export const TEXT = {
  HEADING_PREFIX: 'Hi ',
  SUBMIT_BUTTON_LABEL: 'Verify mobile number',
  LATER_BUTTON_LABEL: 'Later',
};

export const NUDGE_LOCAL_STORAGE_KEY_NAME = 'otp_nudge_data';
